export const ENTIRE_GROUP_NAME = "Entire Population";
